export const getErrorText = (error) => {
	let toasterror = 'Something went wrong!';
	typeof error?.response?.data?.data === 'string' && (toasterror = error.response.data.data);
	typeof error?.response?.data?.data === 'object' &&
		(toasterror =
			error.response.data.data?.messages && error.response.data.data?.messages[0]?.message);
	return toasterror;
};
